/**
 * Operator-facing PT labels and status forms for Customer Workspace.
 * Enums stay API-canonical in types; display forms live here only.
 */

import type {
  ClientStatus,
  ProjectStatus,
  WebsiteEnvironment,
  WebsiteStatus,
} from "./field-map.js";

export const formatClientStatus = (status: ClientStatus): string => {
  switch (status) {
    case "ACTIVE":
      return "Ativo";
    case "ARCHIVED":
      return "Arquivado";
  }
};

export const formatWebsiteStatus = (status: WebsiteStatus): string => {
  switch (status) {
    case "ACTIVE":
      return "Ativo";
    case "INACTIVE":
      return "Inativo";
  }
};

export const formatWebsiteEnvironment = (environment: WebsiteEnvironment): string => {
  switch (environment) {
    case "PRODUCTION":
      return "Produção";
    case "STAGING":
      return "Staging";
  }
};

export const formatProjectStatus = (status: ProjectStatus): string => {
  switch (status) {
    case "DRAFT":
      return "Rascunho";
    case "PLANNED":
      return "Planeado";
    case "IN_PROGRESS":
      return "Em curso";
    case "ON_HOLD":
      return "Em pausa";
    case "COMPLETED":
      return "Concluído";
    case "CANCELLED":
      return "Cancelado";
  }
};

export const isPositiveWebsiteStatus = (status: WebsiteStatus): boolean => status === "ACTIVE";

export const isPositiveClientStatus = (status: ClientStatus): boolean => status === "ACTIVE";

export const isPositiveProjectStatus = (status: ProjectStatus): boolean =>
  status === "IN_PROGRESS" || status === "PLANNED" || status === "COMPLETED";
